import { FullscreenLoader } from '@dealstack/frontend/shared/components/loaders/FullLoaderScreenLoader/FullLoaderScreenLoader';
import { useGlobalConfig } from '@dealstack/frontend/shared/globalConfig';
import { authStartUrl } from '@dealstack/frontend/shared/pages/AuthStart/startHostedAuth';
import { LinkExpiredNotice } from '@dealstack/frontend/shared/pages/LinkExpiredNotice/LinkExpiredNotice';
import { replaceWith } from '@dealstack/frontend/shared/redirecting';
import { ApplicationType } from '@dealstack/shared/lib/generated';
import { isInvitationToken } from '@dealstack/shared/lib/common/invitationLink';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

interface Props {
	applicationType: ApplicationType;
	loginRoute: string;
}

export const LegacyInvitationLink = ({ applicationType, loginRoute }: Props) => {
	const globalConfig = useGlobalConfig();
	const [searchParams] = useSearchParams();
	const tokenParam = searchParams.get('token');
	const invitationToken = isInvitationToken(tokenParam) ? tokenParam : null;

	useEffect(() => {
		if (invitationToken) {
			replaceWith(authStartUrl(globalConfig.apiUrl, applicationType, invitationToken));
		}
	}, [invitationToken]);

	if (invitationToken) {
		return <FullscreenLoader name="pageLoading" />;
	}

	return <LinkExpiredNotice kind="invitation" loginRoute={loginRoute} />;
};
